/* Lifts the Shopify chat pill above the sticky add-to-cart bar on product pages. */
(() => {
  const bar = () => document.querySelector('.sticky-add-to-cart__wrapper');
  const place = () => {
    const chat = document.querySelector('shopify-chat');
    const walk = (r) => { for (const e of r.querySelectorAll('*')) { if (e.classList && e.classList.contains('activator-nudge')) return e; if (e.shadowRoot) { const f = walk(e.shadowRoot); if (f) return f; } } return null; };
    const nudge = chat && walk(chat.shadowRoot || chat);
    const b = bar();
    if (!nudge) return;
    const r = b && b.getBoundingClientRect();
    const h = r && r.height > 0 && r.top < innerHeight ? innerHeight - r.top : 0;
    nudge.style.bottom = (h ? h + 12 : 20) + 'px';
    const label = nudge.querySelector('.activator__label');
    if (label) label.style.display = window.matchMedia('(max-width: 749px)').matches ? 'none' : '';
  };
  setInterval(place, 300);
  addEventListener('resize', place);
})();
